import React, { useEffect, useState } from 'react'
import { titleMark } from '../data/record'

// The film's own wordmark, at the top of every page except the home page,
// where the hero already carries it large.
//
// It holds for the first stretch of the page and then fades, so it does not
// follow the reader all the way down.

const SiteMark = () => {
  const [faded, setFaded] = useState(false)

  useEffect(() => {
    const onScroll = () => setFaded(window.scrollY > 900)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <a className={`site-mark ${faded ? 'is-faded' : ''}`} href='/' aria-label='The Girl and Her Piano, home'>
      <img src={titleMark} alt='The Girl and Her Piano' />
    </a>
  )
}

export default SiteMark
